
























































import ActionFeedback from '@/components/ActionFeedback.vue'
import ConfirmRouteChangeDialog from '@/components//ConfirmRouteChangeDialog.vue'
import GlobalError from '@/components/GlobalError.vue'
import { IHeaderMenuItem } from '@/types/menu'
import Vue from 'vue'
import Component from 'vue-class-component'
import PageToolbar from './components/PageToolbar/index.vue'

@Component < App > ({
  components: {
    'action-feedback': ActionFeedback,
    'global-error': GlobalError,
    'confirm-route-change-dialog': ConfirmRouteChangeDialog,
    'page-toolbar': PageToolbar,
  },
})
export default class App extends Vue {
  public items: IHeaderMenuItem[] = [
    {
      href: 'transco-providers',
      title: 'Fournisseurs',
      icon: 'business',
    },
    {
      href: 'transco-products',
      title: 'Produits',
      icon: 'shopping_cart',
    },
  ]

  public showSidebar: boolean = false

  get isLoadingApp(): boolean {
    return this.$store.getters.isLoadingApp
  }

}
